import script from "./PostDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./PostDetailView.vue?vue&type=style&index=0&id=827876f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827876f6"]])

export default __exports__